module.exports = __webpack_public_path__ + "static/img/adorn.994c261d.png";